import React from 'react';
import { connect } from 'react-redux';
import { IAppState } from 'types/app';

import Deck from './components/Deck';
import Hand from './components/Hand';

function Cards(props: ReturnType<typeof mapStateToProps>) {
  const { showOps } = props;
  if (!showOps) {
    return null;
  }

  return (
    <div className="cards">
      <Deck />
      <Hand />
    </div>
  );
}

Cards.displayName = 'Cards';

const mapStateToProps = ({ map: { showOps } }: IAppState) => ({ showOps });

export default connect(mapStateToProps)(Cards);
